import { createFileRoute, redirect } from "@tanstack/react-router";
export const Route = createFileRoute("/_app/rapportera/")({
  beforeLoad: () => {
    throw redirect({
      to: "/karta"
    });
  }
});